// extracted by mini-css-extract-plugin
export default {"title":"TitleComponent_title__4JSQT","subtitle":"TitleComponent_subtitle__stMPg"};